import { nanoid } from "nanoid";
import Dex3 from "./Dex3.tsx";

export default function YanDexAd(props: any) {
  useAdBodyClass(props.type, props.dataPosition);
  const [refreshId, setRefreshId] = useState(nanoid(8));
  useEffect(() => {
    setRefreshId(nanoid(8));
  }, []);
  return <Dex3 key={refreshId} {...props} />;
}
